<template>
	<div class="container">
		<img class="login_1" src="../../static/image/1.png" alt="" srcset="">
		<!-- <img class="login_2" src="https://app.annengyunshu.com/pc/img/2.png" alt="" srcset=""> -->
		<div class="login_3">
			<div class="login_10 flex pointer" v-if="type == 1" @click="typeTop(2)">
				<img class="login_10_1" src="../../static/image/8.png" alt="" srcset="">
				<div class="login_10_2">返回上一步</div>
			</div>
			<div class="login_7" v-if="type == 2">欢迎来到新时代医疗</div>
			<div class="login_7" v-if="type == 1">忘记密码</div>
			<!-- <div class="login_7" @click="qiehuan('zh')">切换中文</div>
	    <div class="login_7" @click="qiehuan('en')">切换英文</div> -->
			<!-- <p>{{ $t('hello') }}</p> -->
			<!-- <div class="login_6 flex">
			<div class="login_61 pointer" :class="type == 1 ? 'xuanz' : ''" @click="typeTop(1)">
				验证码登录
				<div class="login_62" v-if="type == 1"></div>
			</div>
			<div class="login_61 pointer" :class="type == 2 ? 'xuanz' : ''" @click="typeTop(2)">
				密码登录
				<div class="login_62" v-if="type == 2"></div>
			</div>
	    </div> -->
		<div v-if="jiao_type" style="padding: 0px 64px 0 64px;margin-top: 80px;">
			<div class="login_5 flex dibu">
				<img class="login_51" src="../../static/image/3.png" alt="" srcset="">
				<div class="login_52"></div>
				<el-input v-model="phone" :maxlength='11' type='number' placeholder="请输入手机号"></el-input>
			</div>
			<div class="login_5 flex " v-if="type == 1">
				<img class="login_51" src="../../static/image/4.png" alt="" srcset="">
				<div class="login_52"></div>
				<el-input v-model="code" :maxlength='6' type='number' placeholder="请输入验证码"></el-input>
				<div class="login_53 pointer">
					<div @click="tioCod" v-if="!timTpe">获取验证码</div>
					<div v-else>{{time}}秒后重新获取</div>
				</div>
			</div>
			<div class="login_5 flex ">
				<img class="login_51" src="../../static/image/5.png" alt="" srcset="">
				<div class="login_52"></div>
				<el-input ref="pwdInput" :type="pwdObj.pwdType" v-model="password" placeholder="请输入密码(6~12位字母+数字)"
					@focus="focusEnd($event)">
			
				</el-input>
				<img slot="suffix" class="img-sty" :src="pwdObj.pwdType === 'text' ? img2 : img1 " fit="scale-down"
					@click="changeye('pwdType','pwdInput')">
			</div>
			<div class="login_8 pointer" v-if="type == 2" @click="typeTop(1)">忘记密码</div>
			<div class="login_4 pointer" @click="toLogo">{{ type == 1? '确定' : '登录' }}</div>
			<div class="login_9 flex">
				<el-checkbox v-model="checked"></el-checkbox>
				<p class="login_9_2">已阅读并同意</p>
				<p class="login_9_1 pointer" @click="drawer1 = true">《用户注册协议》</p>
				<p>与</p>
				<p class="login_9_1 pointer" @click="drawer2 = true">《隐私政策》</p>
			</div>
		</div>
			
			
			<div class="login_12" v-if="!jiao_type">
			    <slide-verify
			          ref="slideRef"
			          :l="42"
			          :r="10"
			          :w="430"
			          :h="260"
			          :imgs="images"
			          slider-text="向右滑动"
			          @success="onSuccess"
			          @fail="onFail"
			          @refresh="onRefresh"
			          @fulfilled="onRefreshComplete"
			          @again="onAgain"
			        >
			    </slide-verify>
				<div class="flex login_13">
					<div class="login_13_2" >向右拖动滑块完成拼图</div>
					<img class="login_13_1 pointer" @click="shauxin" src="../../static/image/34.png" alt="" srcset="">
					<img class="login_13_1 pointer" @click="jiao_type = true" src="../../static/image/33.png" alt="" srcset="">
				</div>
			</div>
			
		</div>
		<!-- 快递协议 -->
		<el-dialog title="用户注册协议" :visible.sync="drawer1" width="1200px">
			<div class="index8">
				<div class="content-h" v-html="detail1.content"></div>
			</div>
		</el-dialog>
		<el-dialog title="隐私政策" :visible.sync="drawer2" width="1200px">
			<div class="index8">
				<div class="content-h" v-html="detail2.content"></div>
			</div>
		</el-dialog>
		<div class="login_11 flex">
			<img class="login_11_1" src="../../static/image/2.png" alt="" srcset="">
			<div class="login_11_2">新时代医疗</div>
		</div>
		
	</div>
</template>

<script>
	import CryptoJS from '../api/crypto-js.min.js'
	export default {
		components: {
			
		},
		data() {
			return {
				jiao_type:true,
				images: [
					// 'https://s.annengyunshu.com/uploads/images/ee/389bf5be53fd41a2b5f13c4ad29202.png',
					// 'https://s.annengyunshu.com/uploads/images/57/f489dd387de7b7373f8aa8d3a2b1e7.png',
				],
				tipsMsg:'',
				isSuccess: true,
				drawer1: false,
				drawer2: false,
				checked: false,
				password: '',
				phone: '',
				code: '',
				timTpe: false,
				td: '',
				type: 2,
				time: 60,
				img1: require('../../static/image/6.png'),
				img2: require('../../static/image/7.png'),
				pwdObj: {
					pwdType: 'password'
				},
				pc_login_background: '',
				detail1: '',
				detail2: '',
				post_type: false,
				isVerified: false,
				userinfo:'',
			}
		},
		created() {
			this.getItemType()
			this.post641568f1b6f871()
			this.post641568f1b6f872()
			this.post691d8238c8328()
		},

		methods: {
			// 刷新图形
			shauxin(){
				
				this.$refs.slideRef.reset();
			},
			 // 成功回调
			        onSuccess(){
			            // this.tipsMsg = '恭喜您，验证成功啦！';
						console.log('恭喜您，验证成功啦！')
						window.sessionStorage.setItem('token', this.userinfo.user_token);
						window.sessionStorage.setItem('user', JSON.stringify(this.userinfo));
						window.sessionStorage.setItem('statusType', 0);
						this.$message.success('登录成功');
						setTimeout(() => {
							this.$router.push({
								name: 'index',
								params: {},
							});
						}, 1000)
			            this.isSuccess = true;
			        },
			        // 失败回调
			        onFail(){
			            this.tipsMsg = '验证失败，请重试哦！';
			            // this.isSuccess = false;
			        },
			        // 点击刷新回调
			        onRefresh(){
						// console.log(1234)
			            this.tipsMsg = ''
			        },
			        // 刷新成功后回调
			        onRefreshComplete(){
			        this.tipsMsg = ''
			        this.isSuccess = true;
			        },
			        // 检测到非人为操作
			        onAgain() {
			        this.tipsMsg = "再试一次吧～"
			        this.$refs.slideRef.reset();
			        },
		
			post691d8238c8328(){
				this.$api.post(this.$apiUrls.post691d8238c8328, {}).then((res) => {
					if (res.code == 1) {
						// console.log(res,123)
						if(res.data && res.data.length > 0){
							let images = res.data[0].thumb
							let list = []
							list.push(images)
							this.images = list
						}
						// console.log(this.images,123)
						// let images = 'https://yufabu.saizhuge.net' + res.data.result.thumb
						// this.images.push(images)
						// this.img_icon = 
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 用户注册协议
			post641568f1b6f871() {
				this.$api.post(this.$apiUrls.post641568f1b6f87, {
					column_id: 1
				}).then((res) => {
					if (res.code == 1) {
						this.detail1 = res.data
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 隐私政策
			post641568f1b6f872() {
				this.$api.post(this.$apiUrls.post641568f1b6f87, {
					column_id: 2
				}).then((res) => {
					if (res.code == 1) {
						this.detail2 = res.data
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			// qiehuan(type){
			// 	this.$i18n.locale = type
			// },
			// 时间
			getItemType() {
				// this.$api.post(this.$apiUrls.post60e264f907fe9).then((res) => {
				// 	if (res.code == 1) {
				// 		this.pc_login_background = res.data.pc_login_background
				// 	} 
				// })
			},
			toLogo() {
				// console.log(this.password,123)
				// return
				if (!this.phone) {
					this.$message.error('请输入手机号');
					return
				} else {
					let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
					// console.log(reg.test(this.phone))
					if (!reg.test(this.phone)) {
						this.$message.error('请输入正确的手机号！');
						return
					}
				}
				if (this.type == 1) {
					if (!this.code) {
						this.$message.error('请输入验证码');
						return
					}
				} else {
					if (!this.password) {
						this.$message.error('请输入密码');
						return
					}
				}
				if (!this.checked) {
					this.$message.error('请勾选协议');
					return
				}
				let url = ''
				let page = {}
				if (this.type == 1) { //忘记密码
					url = this.$apiUrls.post5caeeba9866aa
					page.code = this.code
					page.account = this.phone
					page.password = this.password
					page.type = 3
					page.account_type = 'mobile'

				} else {//账号密码登录
					url = this.$apiUrls.post5c78dbfd977cf
					page.account = this.phone
					page.account_type = 'mobile'
					page.password = this.password
					page.is_pc = 1

				}
				this.$api.post(url, page).then((res) => {
					if (res.code == 1) {
						if (this.type == 1) {
							this.typeTop(2)
						} else {
							this.userinfo = res.data.userinfo
							// console.log(this.images.length,11111111)
							// return
							if(this.images.length > 0){
								this.jiao_type = false
							}else{
								window.sessionStorage.setItem('token', res.data.userinfo.user_token);
								window.sessionStorage.setItem('user', JSON.stringify(res.data.userinfo));
								window.sessionStorage.setItem('statusType', 0);
								this.$message.success('登录成功');
								setTimeout(() => {
									this.$router.push({
										name: 'index',
										params: {},
									});
								}, 1000)
							}
							
							
						}

					} else {
						this.$message.error(res.msg);
						return
					}
				})

			},
			// 切换
			typeTop(type) {
				this.type = type
				this.detal()
			},
			// 清空数据
			detal() {
				// this.phone = ''
				this.password = ''
				this.code = ''
				this.timTpe = false
				clearInterval(this.td);
				this.time = 60
			},
			encrypt(text) {
				let key = CryptoJS.enc.Utf8.parse('c81b7d38b57d7dbabcd3c38dc37446f4')
				let srcs = CryptoJS.enc.Utf8.parse(text)
				let encrypted = CryptoJS.AES.encrypt(srcs, key, {
					mode: CryptoJS.mode.ECB,
					padding: CryptoJS.pad.Pkcs7
				})
				return encrypted.toString()
			},
			getUUID() {
				const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
				return S4() + S4() + '' + S4() + '' + S4() + '' + S4() + '' + S4() + S4() + S4() + new Date().getTime()
			},
			getCaptchaData() {
				let device = ''

				let DEVICE_ID = ''
				if (window.sessionStorage.getItem('DEVICE_ID')) {
					DEVICE_ID = window.sessionStorage.getItem('DEVICE_ID')
				}
				// let DEVICE_ID = uni.getStorageSync('DEVICE_ID')
				if (!DEVICE_ID) {
					DEVICE_ID = this.getUUID()
					window.sessionStorage.setItem('DEVICE_ID', DEVICE_ID);
				}
				device = DEVICE_ID
				// 获取当前时间戳单位秒
				return this.encrypt(JSON.stringify({
					device,
					timestamp: Math.floor(new Date().getTime() / 1000)
				}))
			},
			post666a45d4d6bb4(key) {
				this.$api.post(this.$apiUrls.post666a45d4d6bb4, {
					captcha_data: this.getCaptchaData(),
					accountType: 'phone',
					captcha_key: key,
					is_test: 1,
					mobile: this.phone,
					type: 3,
				}).then((res) => {
					if (res.code == 1) {
						if (res.data.code) {
							this.$message.error(res.data.code);
						} else {
							this.$message.error('发送成功！');
						}
						let that = this
						this.td = setInterval(function() {
							// console.log(that.time ,'执行')
							// 判断剩余秒数
							if (that.time == 0) {
								// 清除定时器和复原按钮
								that.timTpe = false
								clearInterval(that.td);
							} else {
								that.timTpe = true
								that.time--;
							}
						}, 1000);
						this.post_type = false
					} else {
						this.post_type = false
					}
					// console.log(res,1111111111)

				})
			},
			tioCod() {
				if (!this.phone) {
					this.$message.error('请输入手机号');
					return
				} else {
					let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
					// console.log(reg.test(this.phone))
					if (!reg.test(this.phone)) {
						this.$message.error('请输入正确的手机号！');
						return
					}
				}

				if (this.post_type) {
					return
				}
				this.post_type = true
				this.$api.post(this.$apiUrls.post6668f5d1d434e, {
					captcha_data: this.getCaptchaData()
				}).then((res) => {
					if (res.code == 1) {
						this.post666a45d4d6bb4(res.data.captcha_key)
					} else {
						this.post_type = false
					}
					// console.log(res,1111111111)

				})
				return








				this.$api.post(this.$apiUrls.GetVerifyCode, {
					mobile: this.phone,
					is_test: 0
				}).then((res) => {
					if (res.code == 1) {
						if (res.data.code) {
							this.$message.error(res.data.code);
						} else {
							this.$message.error('发送成功！');
						}

						let that = this
						this.td = setInterval(function() {
							// console.log(that.time ,'执行')
							// 判断剩余秒数
							if (that.time == 0) {
								// 清除定时器和复原按钮
								that.timTpe = false
								clearInterval(that.td);
							} else {
								that.timTpe = true
								that.time--;
							}
						}, 1000);
					} else {
						this.$message.error(res.msg);
						return
					}
				})




			},
			changeye(typeName, refName) {
				this.$set(
					this.pwdObj,
					`${typeName}`,
					this.pwdObj[`${typeName}`] === 'password' ? 'text' : 'password'
				)
				this.$refs[`${refName}`].focus()
			},
			//点击查看密码图标使光标定位到最后
			focusEnd(e) {
				//input获取光标显示在最后
				const obj = e.srcElement,
					// obj.focus()
					len = obj.value.length
				//光标定位要加上 setTimeOut，不然就会重新光标定位失败
				setTimeout(() => {
					obj.selectionStart = obj.selectionEnd = len
				}, 60)
			},
		}
	}
</script>

<style lang="scss" scoped>
	
	::v-deep {
		.el-dialog__body {
			padding-top: 0 !important;
		}

		.el-input {
			height: 20px;
			width: 60%;
		}

		.el-input input {
			height: 20px;
			line-height: 20px;
			margin-top: -10px;
			background: rgba(0, 0, 0, 0);
			border: none;
		}

		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
			-webkit-appearance: none;
		}

		input[type="number"] {
			-moz-appearance: textfield;
		}
		// 修改滑块轨道背景色
		.slide-verify-track {
			background-color: red !important;
		}
		// 修改成功后的提示文字颜色
		.slide-verify-success {
		  background-color: red !important;
		}
		// 未滑动的样式
		.slide-verify-slider {
			// width: 160px !important;
			height: 22px !important;
			background: #EEEEEE !important;
			border-radius: 20px 20px 20px 20px !important;
		}
		// 滑块样式
		.slide-verify-slider-mask-item{
			width: 83px !important;
			height: 40px !important;
			background: url(../../static/image/32.png) 0 0 no-repeat !important;
			background-size: 100% 100% !important;
			border: none !important;
			box-shadow: none !important;
			top: -10px !important;
		}
		// 划过的样式
		.container-fail .slide-verify-slider-mask,
		.container-active .slide-verify-slider-mask,
		.container-success .slide-verify-slider-mask{
			height: 22px !important;
		}
		.container-fail .slide-verify-slider-mask-item,
		.container-active .slide-verify-slider-mask-item,
		.container-success .slide-verify-slider-mask-item{
			background-color: none !important;
		}
		.container-success .slide-verify-slider-mask-item[data-v-7b054e17]
		// 中间箭头
		.slide-verify-refresh-icon,
		.slide-verify-slider-text,
		.slide-verify-slider-mask-item-icon{
			display: none !important;
		}
		.vue-monoplasty-slide-verify .vue-monoplasty-slide-verify__slider {
		    left: 50% !important; /* 例如设置为50% */
		}
	}

	.container {
		width: 100%;
		height: 100vh;
		min-height: 900px;
		border: 0;
		position: relative;
		// background: url('../../static/image/1.png') 0 0 no-repeat;
		// background-size: 100% 100%;
	}

	.login_1 {
		width: 100%;
		height: 100%;
	}

	.login_2 {
		width: 126px;
		height: 67px;
		position: absolute;
		top: 46px;
		left: 58px;
	}

	.login_3 {
		width: 510px;
		height: 560px;
		// padding: 0px 64px 0 64px;
		background: #FFFFFF;
		position: absolute;
		top: 202px;
		right: 180px;
	}

	.login_4 {
		width: 380px;
		height: 56px;
		background: #004EA1;
		border-radius: 4px 4px 4px 4px;
		opacity: 1;
		margin: 40px auto 0;
		font-size: 20px;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 56px;
		text-align: center;
	}

	.login_5 {
		width: 400px;
		// height: 56px;
		border: 1px solid #EEEEEE;
		// background: #F5F6F7;
		border-radius: 4px 4px 4px 4px;
		opacity: 1;
		margin: 0px auto 20px;
		padding: 13px 20px 15px;
		box-sizing: border-box;
	}

	.dibu {
		margin-bottom: 20px !important;
	}

	.login_51 {
		width: 20px;
		height: 20px;
	}

	.login_52 {
		width: 1px;
		height: 14px;
		background: #D2D5D8;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		margin: 3px 0 0 20px;
	}

	.login_53 {
		margin: 0 0 0 auto;
		font-size: 20px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #004EA1;
	}

	.img-sty {
		width: 22px;
		height: 22px;
		margin-left: auto;
	}

	.login_6 {
		margin: 0 0 40px 0;
	}

	.login_61 {
		font-size: 24px;
		font-weight: 400;
		color: #999999;
		position: relative;
		margin: 0 48px 0 0;
	}

	.login_62 {
		width: 28px;
		height: 4px;
		background: #333333;
		position: absolute;
		left: 50%;
		top: 37px;
		transform: translateX(-50%);
	}

	.login_7 {
		font-size: 26px;
		font-weight: 900;
		color: #333333;
		margin: 80px 0 0px 0;
		text-align: center;
	}

	.xuanz {
		color: #333333;
	}

	.login_8 {
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		width: 380px;
		text-align: right;
		margin: 20px 0 0 0;
	}

	.login_9 {
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		width: 380px;
		align-content: center;
		justify-content: center;
		margin: 20px 0 0 0;
	}

	.login_9_1 {
		color: #004EA1;
	}

	.login_9_2 {
		margin: 0 0px 0 10px;
	}

	.login_10 {
		position: absolute;
		left: 22px;
		top: 25px;
		justify-content: center;
		/* 主轴居中 */
		align-items: center;
		/* 交叉轴居中 */
	}

	.login_10_1 {
		width: 12px;
		height: 12px;
	}

	.login_10_2 {
		font-weight: 400;
		font-size: 16px;
		color: #004EA1;
	}

	.login_11 {
		position: absolute;
		top: 53px;
		left: 80px;
	}

	.login_11_1 {
		width: 42px;
		height: 42px;
	}

	.login_11_2 {
		font-weight: bold;
		font-size: 26px;
		color: #004EA1;
		margin: 0 0 0 14px;
	}

	.index8 {
		height: 500px;
		overflow-y: auto;
	}
	.login_12{
		width: 450px;
		height: 384px;
		background: #FFFFFF;
		border-radius: 0px 0px 0px 0px;
		border: 1px solid #EEEEEE;
		margin: 30px 30px 0 30px;
		padding: 10px;
		box-sizing: border-box;
	}
	.login_13{
		font-weight: 400;
		font-size: 24px;
		color: #333333;
		margin-top: 20px;
	}
	.login_13_1{
		width: 28px;
		height: 28px;
		margin-left: 30px;
	}
	.login_13_2{
		margin-right: auto;
	}
</style>